export function makeSuccessHandler({ clientName } = {}) {
  return function handleSuccess(response) {
    if (process.server) {
      const { logMsg } = destructResponse(response, clientName)
      console.log(logMsg)
    }

    return response
  }
}

export function makeErrorHandler({
  clientName,
  onErrorHandled,
  redirectToLogin,
  showErrorPage,
  showErrorToast
}) {
  return function handleError(error) {
    if (error?.config?.blockInterceptions || error.__CANCEL__) {
      return Promise.reject(error)
    }

    if (error?.isAxiosError) {
      const { data, logMsg, method, status, statusText } = destructResponse(
        error.response,
        clientName
      )

      if (process.server) {
        console.error(logMsg)
        data?.messages?.forEach(console.error)
      }

      if (status === 401 || status === 403) {
        redirectToLogin()
      } else if (method === 'GET') {
        showErrorPage(status, statusText)
      } else if (status === 400) {
        showErrorToast(data)
      } else if (status === 409) {
        showErrorToast(data, { type: 'warning' })
      } else {
        showErrorPage(status, statusText)
      }
    } else {
      if (process.server) {
        console.error(`UNKNOWN ERROR IN API REQUEST`, error)
      }

      showErrorToast()
    }

    if (typeof onErrorHandled === 'function') {
      onErrorHandled()
    }

    return Promise.reject(error)
  }
}

function destructResponse({ config, data, status, statusText }, clientName) {
  const method = config.method.toUpperCase()

  const logMsgPartial = `API:[${method}][${status}][${config.url}]: ${statusText}`
  const logMsg = typeof clientName === 'undefined'
    ? logMsgPartial
    : `CLIENT: ${clientName} - ${logMsgPartial}`

  return { data, logMsg, method, status, statusText }
}
